import React from 'react';

const RichContentSection = ({ section }) => {
  const getPaddingClass = (padding) => {
    switch (padding) {
      case 'none':
        return 'p-0';
      case 'small':
        return 'p-3';
      case 'normal':
        return 'p-6';
      case 'large':
        return 'p-8';
      case 'xl':
        return 'p-12';
      default:
        return 'p-6';
    }
  };

  const getBorderRadiusClass = (radius) => {
    switch (radius) {
      case 'none':
        return 'rounded-none';
      case 'sm':
        return 'rounded-sm';
      case 'md':
        return 'rounded-md';
      case 'lg':
        return 'rounded-lg';
      case 'xl':
        return 'rounded-xl';
      case 'full':
        return 'rounded-full';
      default:
        return 'rounded-none';
    }
  };

  const getBorderClass = (border) => {
    switch (border) {
      case 'none':
        return 'border-0';
      case 'thin':
        return 'border';
      case 'normal':
        return 'border-2';
      case 'thick':
        return 'border-4';
      default:
        return 'border-0';
    }
  };

  const getFontSizeClass = (size) => {
    switch (size) {
      case 'xs':
        return 'text-xs';
      case 'sm':
        return 'text-sm';
      case 'base':
        return 'text-base';
      case 'lg':
        return 'text-lg';
      case 'xl':
        return 'text-xl';
      case '2xl':
        return 'text-2xl';
      case '3xl':
        return 'text-3xl';
      default:
        return 'text-base';
    }
  };

  if (!section.title && !section.content) {
    return null;
  }

  return (
    <div
      className={`${getPaddingClass(
        section.styling?.padding || 'normal'
      )} ${getBorderRadiusClass(
        section.styling?.borderRadius || 'none'
      )} ${getBorderClass(
        section.styling?.border || 'none'
      )} ${getFontSizeClass(section.styling?.fontSize || 'base')}`}
      style={{
        backgroundColor:
          section.styling?.backgroundColor === 'transparent'
            ? 'transparent'
            : section.styling?.backgroundColor || 'transparent',
        color: section.styling?.textColor || '#374151',
        borderColor:
          section.styling?.border !== 'none' ? '#d1d5db' : 'transparent'
      }}>
      {section.title && (
        <h3
          className="text-2xl font-semibold mb-4"
          dangerouslySetInnerHTML={{ __html: section.title }}
        />
      )}
      {section.content && (
        <div
          className="leading-relaxed"
          dangerouslySetInnerHTML={{ __html: section.content }}
        />
      )}
    </div>
  );
};

export default RichContentSection;
